import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import mainBackground from './img/background.jpg'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro320">
      <div className="intro320desktop animated-intro-large screen">
        <img className="background-p4EdWL" src={background || mainBackground} />
        <div className="button-p4EdWL">
          <div
            className="site-de-casamento-e-CpwLjN helveticaneue-regular-normal-white-10px"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <button className="button-CpwLjN" onClick={onSkipIntro}>
            <div className="pular-introduo-fo8x79 helveticaneue-medium-white-12px">
              {buttonMessage}
            </div>
          </button>
        </div>
        <div className="couple-name-p4EdWL notranslate">
          <div className="m-e-VF7rnS alice-normal-white-72px-2 bp1-animate-enter">
            <span className="span0-cOk0Lc alice-normal-mine-shaft-72px">
              {coupleSimplifiedName.bride}
            </span>
            {coupleSimplifiedName.groom && (
              <>
                <span className="span2-cOk0Lc alice-normal-silver-72px">
                  &amp;
                </span>
                <span className="span4-cOk0Lc alice-normal-mine-shaft-72px">
                  {coupleSimplifiedName.groom}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="intro320mobile animated-intro-small screen">
        <img className="background-4QFuFN" src={background || mainBackground} />
        <div className="button-4QFuFN">
          <div
            className="site-de-casamento-e-YrZHDo helveticaneue-regular-normal-white-10px"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-YrZHDo" onClick={onSkipIntro}>
            <div className="pular-introduo-8N8PwH helveticaneue-medium-white-12px">
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-4QFuFN notranslate">
          <div className="m-e-DINxli alice-normal-white-72px-2 bp2-animate-enter">
            <span className="span0-YY0MAN alice-normal-mine-shaft-72px">
              {coupleSimplifiedName.bride}
            </span>
            {coupleSimplifiedName.groom && (
              <>
                <span className="span2-YY0MAN alice-normal-silver-72px">
                  &amp;
                </span>
                <span className="span4-YY0MAN alice-normal-mine-shaft-72px">
                  {coupleSimplifiedName.groom}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
